mutation updateCompanyLinks($input: UpdateCompanyLinksInput!) {
  updateCompanyLinks(input: $input)
}
